module.exports = __webpack_public_path__ + "img/stripes.4cdec52c.svg";